import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { api } from '../consts/url';
import { PermissionModels } from '@share-models';

@Injectable({ providedIn: 'root' })
export class PermissionsService {
  constructor(private http: HttpClient) {}

  public getUserPermissions(): Observable<PermissionModels.UserPermissionsState> {
    return this.http.get<PermissionModels.UserPermissionsState>(
      api.permissions.getUserPermissions,
    );
  }
}
